import { Status } from '../enums/status/status.enum';
export class DisplayConditions {
    static canShowEditWorkshopDamages(smartphoto) {
        return [Status.COMPLETED, Status.REVIEWED, Status.BODYSHOP_REOPENED].includes(smartphoto.status);
    }
    static canShowEditDocumentImages(smartphoto, company) {
        if (company.smartphoto.permissions?.edit) {
            return company.smartphoto.permissions.edit.information.includes(smartphoto.status);
        }
        return !company.disableEditing && smartphoto.status !== Status.CANCELLED;
    }
    static canShowEditSummary(company) {
        return !company.disableEditing;
    }
    static canShowViewDetailHeader(smartphoto) {
        return [Status.COMPLETED, Status.REVIEWED, Status.BODYSHOP_REOPENED, Status.REPAIRED].includes(smartphoto.status);
    }
    static canShowVehicleLifeCycle(smartphoto) {
        return [Status.COMPLETED, Status.REVIEWED, Status.REPAIRED, Status.CANCELLED].includes(smartphoto.status);
    }
    static canShowEditBasket(company) {
        return company.baskets.get().length > 0;
    }
    static canShowBasket(smartphoto, company) {
        const { basket, type, status } = smartphoto;
        const canShowEditBaskets = DisplayConditions.canShowEditBasket(company);
        const basketsEnabled = type === 'Claim' || canShowEditBaskets;
        const statusEnabled = [Status.COMPLETED, Status.REVIEWED, Status.REPAIRED, Status.BODYSHOP_REOPENED].includes(status);
        return basket !== undefined && basketsEnabled && statusEnabled;
    }
    static canShowResendBodyShop(smartphoto) {
        const allowedStatuses = [Status.REVIEWED, Status.BODYSHOP_REOPENED];
        return smartphoto.additionals.emails.length > 0 && allowedStatuses.includes(smartphoto.status);
    }
    static canShowReopen(smartphoto) {
        const { status, attributes } = smartphoto;
        const statusCanReopen = [Status.COMPLETED, Status.CANCELLED].includes(status);
        const fromSmartVideo = attributes.executionChannel === 'FromSmartVideo';
        return statusCanReopen && !fromSmartVideo;
    }
    static canShowCancel(smartphoto) {
        return smartphoto.status !== Status.CANCELLED;
    }
    static canShowReview(smartphoto) {
        return smartphoto.status !== Status.REVIEWED;
    }
    static canShowResend(smartphoto) {
        const { status, notificationChannel } = smartphoto;
        const enabled = [Status.NEW, Status.IN_PROGRESS, Status.REVIEWED, Status.REOPENED, Status.BODYSHOP_REOPENED, Status.REPAIRED].some((allowResendStatus) => status === allowResendStatus);
        return enabled && notificationChannel !== 'none';
    }
    static canShowEditDamages(smartphoto, company) {
        const { status } = smartphoto;
        const { disableCostEstimationUpdate } = company;
        return (!disableCostEstimationUpdate &&
            [Status.COMPLETED, Status.CANCELLED, Status.REVIEWED, Status.REOPENED, Status.BODYSHOP_REOPENED].includes(status));
    }
    static canShowEditInformation(smartphoto, company) {
        const { status } = smartphoto;
        const { disableEditing, smartphoto: smartphotoFromCompany } = company;
        if (smartphotoFromCompany.permissions?.edit) {
            return smartphotoFromCompany.permissions.edit.information.includes(status);
        }
        return !disableEditing && [Status.NEW, Status.IN_PROGRESS, Status.CANCELLED, Status.COMPLETED, Status.REOPENED].includes(status);
    }
    static canShowGT(smartphoto, company) {
        const { estimateProvider } = company;
        if (estimateProvider?.name !== 'GT') {
            return false;
        }
        if (![Status.COMPLETED, Status.REVIEWED].includes(smartphoto.status)) {
            return false;
        }
        const hasDamageReplace = smartphoto.getAllDamages().some(({ estimation }) => estimation.operation === 'replace');
        return !(estimateProvider?.forReplaces && hasDamageReplace);
    }
}
